import React, { createContext, useContext, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimesCircle } from "react-icons/fa";

const ToastContext = createContext();

let toastIdCounter = 0;

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

const variantIcons = {
  success: <FaCheckCircle className="me-2" />,
  danger: <FaTimesCircle className="me-2" />,
  warning: <FaExclamationTriangle className="me-2" />,
  info: <FaInfoCircle className="me-2" />,
};

const variantTitles = {
  success: "Success",
  danger: "Error",
  warning: "Warning",
  info: "Info",
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, variant = "success", duration = 4000) => {
    const id = ++toastIdCounter;
    setToasts((prev) => [...prev, { id, message, variant, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 9999 }}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() => removeToast(toast.id)}
            autohide
            delay={toast.duration}
            bg={toast.variant}
          >
            <Toast.Header>
              {variantIcons[toast.variant] || variantIcons.info}
              <strong className="me-auto">{variantTitles[toast.variant] || "Notice"}</strong>
            </Toast.Header>
            <Toast.Body className={toast.variant === "success" || toast.variant === "danger" ? "text-white" : ""}>
              {toast.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};
